<template>
        <div class="detail-box" ref="detailbox">
            <img src="@/pc/images/detail-bg.png" class="detail-bg">
            <div class="detail-con" ref="element">
                <div class="post-mesg">
                    <h2>{{detail.job_name}} <span>{{detail.salary}}</span></h2>
                    <span class="jobtype">{{detail.job_category}}</span>
                    <p class="info">招聘人数  {{detail.need_num}}<span>|</span>
                        {{detail.edu}}<span>|</span>
                        <em v-for="pla in detail.place">{{pla}} </em>
                        <span>|</span>发布日期 {{detail.update_at}}</p>
                    <p class="jobskill">职位要求</p>
                    <p class="jobskill-c" v-html='detail.content'></p>
                    <p class="jobskill" v-if="detail.weal">福利</p>
                    <p class="jobskill-c">
                        <em v-for="fu in detail.weal">{{fu}}  </em>
                    </p>
                    <Button type="primary" shape="circle" :to="{ name: 'ssend', params: { id: detail.id}}">投递简历</Button>
                </div>
            </div>
        </div>
        <!-- {{id}}这是详情页{{detail}} -->
</template>
<script>
    export default {
        data () {
            return {
                detail:[]
            }
        },
        created() {
            this.getDetail();
        },
        watch: {
            //如果路由变化,执行id更新方法,获取详情
            '$route' : 'getDetail'
        },
        mounted(){
            setTimeout(()=>{
            this.$refs.detailbox.style.height=this.$refs.element.clientHeight+200 +'px';
            },500)
            // console.log(this.$refs.element.clientHeight);
            // console.log(this.$refs.detailbox);
        },
        methods: {
            getDetail(){
                if(this.$route.name != 'sdetail') return;
                this.$axios
                    .get(this.api.getSocialDetail+'/'+this.$route.params.id)
                    .then( res  => {
                        if(res.code){
                            this.detail = res.data;
                        }else {
                            this.$Message.error(res.msg)
                        }
                    });

            }
        }

    }
</script>
<style scoped>
    .detail-box{
        min-height: 93.5vh;
        background: #f3f3f3;
    }
    .detail-bg{
        width: 100%;
        margin-top: -60px;
    }
    .detail-con{
        width: 100%;
        border-radius: 5px;
        padding: 0 17%;
        position: absolute;
        top: 20vh;
    }
    .post-mesg{
        background: #fff;
        border-radius: 5px;
        padding: 10px 30px;
    }
    .post-mesg h2{
        margin: 20px 0;
    }
    .post-mesg h2 span{
        color: #359265;
        float:right;
        font-weight: 100;
    }
    .jobtype{
        color: #969696;
    }
    .info{
        color: #222;
        margin: 10px 0;
    }
    .info span{
        color: #d6d6d6;
        margin: 0 10px;
    }
    .jobskill{
        color: #969696;
        font-size: 1rem;
        margin: 20px 0;
    }
    .jobskill-c{
        color: #222;
        margin: 10px 0;
    }
    .jobskill-c img{
        max-width: 100%;
    }
    .post-mesg Button{
        padding: 8px 34px;
        margin: 30px 0;
        box-shadow: 0px 10px 10px -10px rgba(53, 147, 102, .8);
    }
</style>

